import React from 'react'
import { ICONS } from '@Const/common'
import { NavLink, useRouteError } from 'react-router'
import { isHttpError } from '@App/exceptions/HttpError'
import './index.scss'
import Navigation from '@App/navigation'

const RootErrorBoundary = ({ error: errorProp }: { error?: unknown } = {}) => {
    let title = 'Something went wrong with this page...'
    const routeError = useRouteError()
    const error = errorProp ?? routeError
    const isError = error instanceof Error
    if (isError) {
        if (isHttpError(error)) {
            if (error.statusCode === '503' || error.statusCode === 503) {
                title = "We're undergoing maintenance."
            }
        }
    }
    return (
        <div className="root-error-boundary">
            <nav className="navigation-bar-component" data-testid="navigation-bar-component">
                <div className="accounting-block">
                    <NavLink to={Navigation.login.root()} className="logo-link">
                        <img src={ICONS.mlc_logo_black} alt="MLC Logo" />
                    </NavLink>
                </div>
                <div className="right-block" />
            </nav>
            <div className="global-container">
                <div className="error-holder">
                    <h1>{title}</h1>
                    <pre>{isError ? error.message : JSON.stringify(error)}</pre>
                    <p>
                        <a href="/">Click here to go back home.</a>
                    </p>
                    <p style={{ marginTop: '24px', marginBottom: '24px' }}>
                        If the problem persists, please contact our CX team at{' '}
                        <a href="mailto:support@themlc.com">support@themlc.com</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default RootErrorBoundary
